import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import axios from "axios";
import { apiHost } from "./utils.js";

var ProductController = /*#__PURE__*/function () {
  function ProductController(host, onChange) {
    _classCallCheck(this, ProductController);

    this.status = 0;
    (this.host = host).addController(this);
    this.onChange = onChange;
  }

  _createClass(ProductController, [{
    key: "hostConnected",
    value: function () {
      var _hostConnected = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.host.clientId !== void 0)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.loadProduct();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function hostConnected() {
        return _hostConnected.apply(this, arguments);
      }

      return hostConnected;
    }()
  }, {
    key: "loadProduct",
    value: function () {
      var _loadProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _a, _b, endpoint, response, responseError, data, status;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.status = 0;
                _context2.prev = 1;
                endpoint = "".concat(apiHost, "/v1/products/").concat(this.host.product);

                if (this.host.offerId) {
                  endpoint += "?offer_id=".concat(encodeURIComponent(this.host.offerId));
                }

                _context2.next = 6;
                return axios.get(endpoint, {
                  headers: {
                    "Content-Type": "application/json",
                    "x-api-client-id": this.host.clientId,
                    "x-api-source": "Web Component"
                  }
                });

              case 6:
                response = _context2.sent;
                this.status = 1;
                this.value = response.data;
                this.onChange();
                this.host.requestUpdate();
                _context2.next = 20;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](1);
                this.status = 2;
                responseError = _context2.t0;
                data = (_a = responseError.response) == null ? void 0 : _a.data;
                status = (_b = responseError.response) == null ? void 0 : _b.status;

                if (status === 400) {
                  if (!data._embedded) {
                    this.error = new Error(data.message, {
                      cause: data.error
                    });
                  } else {
                    if (this.host.debug) {
                      console.debug("Failed to retrieve product", data._embedded);
                    }
                  }
                }

              case 20:
                this.host.requestUpdate();

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 13]]);
      }));

      function loadProduct() {
        return _loadProduct.apply(this, arguments);
      }

      return loadProduct;
    }()
  }, {
    key: "render",
    value: function render(renderer) {
      var _a, _b, _c;

      switch (this.status) {
        case 0:
          return (_a = renderer.pending) == null ? void 0 : _a.call(renderer);

        case 1:
          return (_b = renderer.complete) == null ? void 0 : _b.call(renderer, this.value);

        case 2:
          return (_c = renderer.error) == null ? void 0 : _c.call(renderer, this.error);

        default:
          throw new Error("Unexpected status: ".concat(this.status));
      }
    }
  }]);

  return ProductController;
}();

export { ProductController };